import * as React from 'react';

export const BulaIcon: React.FC<React.SVGAttributes<{}>> = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="28"
      height="28"
      fill="none"
      viewBox="0 0 28 28"
      {...props}
    >
      <g clipPath="url(#clip0)">
        <path
          fill="#0EA5DF"
          d="M23.843 5.579H7.438a.82.82 0 0 0-.82.82v20.78c0 .454.367.821.82.821h16.405a.82.82 0 0 0 .82-.82V6.4a.82.82 0 0 0-.82-.821m-10.39 5.469h.207l-.146-.147a.82.82 0 0 1 1.16-1.16l.146.146V9.68a.82.82 0 0 1 1.64 0v.207l.147-.146a.82.82 0 0 1 1.16 1.16l-.146.146h.207a.82.82 0 0 1 0 1.641h-.207l.146.146a.82.82 0 1 1-1.16 1.16l-.146-.146v.207a.82.82 0 0 1-1.64 0v-.207l-.147.146a.82.82 0 0 1-1.16 0 .82.82 0 0 1 0-1.16l.146-.146h-.207a.82.82 0 0 1 0-1.64m7.11 13.67h-9.844a.82.82 0 1 1 0-1.64h9.843a.82.82 0 1 1 0 1.64m0-3.28h-9.844a.82.82 0 0 1 0-1.64h9.843a.82.82 0 0 1 0 1.64m0-3.281h-9.844a.82.82 0 0 1 0-1.641h9.843a.82.82 0 0 1 0 1.64"
        ></path>
        <path
          fill="#EF4F74"
          d="M20.32 0H4.157a.82.82 0 0 0-.82.82v21.876c0 .452.367.82.82.82h.82V6.399c0-1.164.813-2.142 1.902-2.396.021-.01 8.77-2.613 13.44-4.003"
        ></path>
        <path
          fill="#F48473"
          d="m21.905 3.938.01-2.68.016-.026-9.1 2.706z"
        ></path>
      </g>
      <defs>
        <clipPath id="clip0">
          <path fill="#fff" d="M0 0h28v28H0z"></path>
        </clipPath>
      </defs>
    </svg>
  );
};
